export { default } from './TabPanel';

export { default as tabPanelClasses } from './tabPanelClasses';
export * from './tabPanelClasses';
